export const internalURLs = {
  PrinterOverviewURL: '/ucde/hp-all-in-print-plan/overview'
};
